import React, { useState, useEffect } from 'react';
import OperationTable from './OperationTable';
import { format } from 'date-fns';
import axios from 'axios';
import config from '../../../config';
import AlarmModal from '../AlarmModal';

const OperationPage = ({ selectedDate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${config.apiUrl}/prdtStatusSel.do`,
          { stdate: format(selectedDate, 'yyyyMMdd') },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;

        // 디버깅 로그 추가
        console.log('API Response:', apiData);

        // resultData가 빈 배열일 때 모달 열기
        if (apiData.resultData && Array.isArray(apiData.resultData) && apiData.resultData.length === 0) {
          setModalIsOpen(true);
        }

        const transformedData = transformData(apiData);
        setData(transformedData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err.response ? err.response : err);
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);

  // 숫자에 콤마를 추가하는 함수
  const formatNumber = num => {
    return Number(num).toLocaleString();
  };

  const transformData = apiData => {
    console.log('Transform Data Input:', apiData);

    // 머신 데이터 초기화
    const machines = {
      PM2: { machin: 'PM2', data: [] },
      PM3: { machin: 'PM3', data: [] },
    };

    // 데이터 처리
    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const machineKey = entry.HOGIXX === '2' ? 'PM2' : entry.HOGIXX === '3' ? 'PM3' : null;

        if (machineKey) {
          machines[machineKey].data.push({
            startHour: entry.STR_HH,
            startMinute: entry.STR_MM,
            endHour: entry.END_HH,
            endMinute: entry.END_MM,
            runTime: entry.OPTIME,
            speedProduction: entry.SPEEDX,
            speedGoal: entry.PLSPDX,
            speedCause: entry.BSTYNM,
            paperType: entry.PKCDNM,
            standardWeight: entry.BSSWGH,
            actualWeight: entry.SLBSWH,
            theoreticalProduction: formatNumber(entry.PRQUNT),
            spoolWidth: entry.WDTPPR,
          });
        }
      });

      // 데이터 반환
      return [machines.PM2, machines.PM3];
    } else {
      console.error('Expected resultData to be an array but got:', apiData.resultData);
      return [machines.PM2, machines.PM3]; // 빈 데이터가 있어도 상위 헤더는 남겨둠
    }
  };

  const columns = React.useMemo(
    () => [
      { Header: '시', accessor: 'startHour', id: 'startHour' },
      { Header: '분', accessor: 'startMinute', id: 'startMinute' },
      { Header: '시', accessor: 'endHour', id: 'endHour' },
      { Header: '분', accessor: 'endMinute', id: 'endMinute' },
      { Header: '가동시간', accessor: 'runTime', id: 'runTime' },
      { Header: '생산', accessor: 'speedProduction', id: 'speedProduction' },
      { Header: '목표', accessor: 'speedGoal', id: 'speedGoal' },
      { Header: '원인', accessor: 'speedCause', id: 'speedCause' },
      { Header: '지종', accessor: 'paperType', id: 'paperType' },
      { Header: '기준평량', accessor: 'standardWeight', id: 'standardWeight' },
      { Header: '실평량', accessor: 'actualWeight', id: 'actualWeight' },
      { Header: '이론생산량(kg)', accessor: 'theoreticalProduction', id: 'theoreticalProduction' },
      { Header: '스풀폭(m)', accessor: 'spoolWidth', id: 'spoolWidth' },
    ],
    [],
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className='flex flex-col c2_text'>
      {/* 항상 PM2와 PM3 상위 헤더를 렌더링 */}
      <div className='mb-4'>
        <div className='change-w change_2h page_center bg-blue-200 font-bold text-blue-600'>PM2</div>
        <div className='flex whitespace-nowrap overflow-x-auto'>
          <div className='b2-r'>
            <OperationTable columns={columns} data={data.find(machine => machine.machin === 'PM2')?.data || []} />
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <div className='change-w change_2h page_center bg-blue-200 font-bold text-blue-600'>PM3</div>
        <div className='flex whitespace-nowrap overflow-x-auto'>
          <div className='b2-r'>
            <OperationTable columns={columns} data={data.find(machine => machine.machin === 'PM3')?.data || []} />
          </div>
        </div>
      </div>
      <AlarmModal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} />
    </div>
  );
};

export default OperationPage;
